<template>
  <div class="locale" ref="el">
    <span>
      <fa-icon icon="language"></fa-icon>
    </span>
    <select v-model="selected" class="locale__select">
      <option v-for="loc in locales" :key="loc" :value="loc.code">
        {{ loc.title }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed, onMounted, ref, watch } from 'vue'

const props = defineProps({
  color: {
    default: '#fff',
    type: String
  }
})

const selected = ref(null)

const locales = [
  {
    title: 'Русский',
    code: 'ru-RU'
  },
  {
    title: 'English',
    code: 'en-US'
  },
  {
    title: 'Українська',
    code: 'uk-UA'
  }
]

const store = useStore()
const locale = computed(() => store.state.locale)
const el = ref(null)

watch(selected, val => store.commit('SET_LOCALE', val))

onMounted(() => {
  selected.value = locale.value
  el.value.style.setProperty('--color', props.color)
})
</script>

<style lang="scss" scoped>
.locale {
  --color: #fff;

  display: flex;
  align-items: center;
  color: var(--color);
  font-size: 1rem;

  & span {
    font-size: 1.3rem;
  }

  &:hover {
    box-shadow: 0 -2px 0 0 var(--color) inset;
  }
}

.locale__select {
  background-color: transparent;
  border: none;
  color: var(--color);
  padding: 0.3rem;
  outline: none;
  cursor: pointer;
  font-size: 0.9rem;

  & option {
    color: #000;
  }
}
</style>
